export default __webpack_public_path__ + "static/media/IMAGE_10.67ecd8b5.png";